import { useEffect, useState } from 'react'

// __APP_VERSION__ est injecte par Vite au build (vite.config.js define).
// En dev (vite serve), il vaut "dev-{Date.now()}" pour eviter une notif
// permanente. En prod, c'est le timestamp du build du bundle courant.

function getCurrentVersion() {
  try {
    return typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : null
  } catch {
    return null
  }
}

async function fetchRemoteVersion() {
  try {
    const res = await fetch(`/version.txt?_t=${Date.now()}`, {
      cache: 'no-store',
      headers: { 'Cache-Control': 'no-cache' },
    })
    if (!res.ok) return null
    const text = (await res.text()).trim()
    return /^\d+$/.test(text) ? text : null
  } catch {
    return null
  }
}

async function handleUpdate() {
  try {
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map((k) => caches.delete(k)))
    }
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map((r) => r.unregister()))
    }
  } catch { /* ignore */ }
  const url = new URL(window.location.href)
  url.searchParams.set('_v', Date.now().toString())
  window.location.replace(url.toString())
}

export default function UpdateBanner() {
  const [hasUpdate, setHasUpdate] = useState(false)

  useEffect(() => {
    if (hasUpdate) return
    const current = getCurrentVersion()
    if (!current) return

    let cancelled = false
    const check = async () => {
      const remote = await fetchRemoteVersion()
      if (cancelled || !remote) return
      if (remote !== current) {
        setHasUpdate(true)
      }
    }

    // Premier check au mount, puis toutes les 5 min, et au focus de la fenetre
    check()
    const interval = setInterval(check, 5 * 60 * 1000)
    const onFocus = () => check()
    window.addEventListener('focus', onFocus)
    return () => {
      cancelled = true
      clearInterval(interval)
      window.removeEventListener('focus', onFocus)
    }
  }, [hasUpdate])

  if (!hasUpdate) return null

  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 px-4 py-3 rounded-2xl shadow-2xl animate-fade-up"
      style={{
        bottom: 'max(20px, env(safe-area-inset-bottom, 20px))',
        background: 'linear-gradient(135deg, #0d3326, #2d8f5f)',
        color: 'white',
        maxWidth: 'calc(100vw - 40px)',
      }}
    >
      <span className="text-xl">🆕</span>
      <div className="flex-1 min-w-0">
        <div className="font-bold text-sm leading-tight">Nouvelle version disponible</div>
        <div className="text-[10px] opacity-80 leading-tight mt-0.5">Cliquez pour recharger</div>
      </div>
      <button
        onClick={handleUpdate}
        className="px-3 py-1.5 rounded-xl bg-white text-emerald-800 text-xs font-bold hover:bg-emerald-50 transition flex-shrink-0"
      >
        Mettre a jour
      </button>
    </div>
  )
}
